<template>
  <div v-if="infos.length > 0" class="py-[160px] flex flex-col items-center scene-demo">
    <div class="text-[48px] text-center leading-[67px]">
      {{ $t('ying-yong-shi-li') }}
    </div>
    <div class="pt-[80px] pb-[40px] w-full">
      <VideoCarousel v-if="infos.length > 0" :infos="infos"></VideoCarousel>
    </div>
    <UpgradeButton
      :text="$t('mian-fei-shi-yong-ci-chang-jing')"
      @handle="freeUseScene"
      :configType="data?.config_type"
      style="min-width: 238px"
    />
    <!-- <StartBtn
      :width-style="{ width: '238px' }"
      type="small"
      :text="$t('mian-fei-shi-yong-ci-chang-jing')"
      :handler="freeUseScene"
    /> -->
  </div>
</template>

<script setup lang="ts">
import UpgradeButton from '@/components/upgrade-button/index.vue';
import { MockSceneDetails } from '~/api/interface/scene';

const props = defineProps<{ data: typeof MockSceneDetails }>();

import VideoCarousel, { type IInfo } from '../components/video-carousel.vue';
import { useScene } from '../hooks';

const infos = reactive<IInfo[]>([]);

const { handleUse } = useScene();
function getInfos() {
  for (let i = 0; i < props.data.project_templates.length; i++) {
    const template = props.data.project_templates[i];
    infos.push({
      title: template.cover_oss_path,
      url: template.preview_video,
      poster: template.cover_url,
    });
  }
}

const freeUseScene = () => {
  handleUse(props.data.id);
};

getInfos();

defineExpose({
  freeUseScene,
});
</script>
